<template>
  <div class="did">
    <shell>
      <div class="container m-auto">
        <div class="w-full lg:w-1/2 m-auto">
          <t-text lvl="1">Import transactions from Bank of America</t-text>
          <p v-if="error" class="text-red-dark py-6">{{error}}</p>
          <form @submit.prevent="handleSubmit">
          <div class="my-4">
            <t-label>Note Template</t-label>
            <textarea v-model="tpl" class="w-full p-2 leading-normal font-mono border-gray border" rows="6"></textarea>
          </div>
          <diV class="my-4">
            <t-label>BoA TSV Export File</t-label>
            <input ref="file" type="file" name="filename" @change="handleFileChange" class="w-full bg-white p-2 border-gray border" />
          </diV>
          <diV>
            <t-label>BoA Account Name</t-label>
            <input type="text" v-model="accountName" class="p-2 border border-gray" />
          </diV>

          <div class="my-4">
            <h3>Preview</h3>
            <div v-if="notes.length">
              <div class="bg-white my-4" v-for="n in notes.slice(0, 3)"><note :item="{}" :text="n" /></div>
            </div>
            <div v-else class="my-4 p-4 bg-gray-lighter rounded text-gray-darker">
              Select a Bank of America transaction file above in TSV format (tab delimited values)
            </div>
          </div>
          <t-button type="submit" :disabled="disabled || !notes || !notes.length">
            <span v-if="disabled">Uploading...</span>
            <span v-else>Looks good, save the notes</span>
          </t-button>
          </form>
        </div>
      </div>
    </shell>
  </div>
</template>
<script>
 import Papa from 'papaparse'
 const {Liquid} = require('liquidjs')
 
 import { DateTime } from 'luxon'
 import { mapState, mapActions } from 'vuex'
 import eventBus from '@/eventBus'
 import Shell from '@/components/Shell'
 import Note from '@/components/Note'
 
 import api from '@/api'

 const engine = new Liquid()

 const TPL = `{{date}}
/"The Books"

{{bean}}

{{description}}`

 const ACCOUNT_NAME = 'Account Name'

 export default {
   props: {

   },

   components: { Shell },
   data () {
     return {
       tpl: TPL,
       notes: [],
       accountName: ACCOUNT_NAME,
       rows: [],
       error: '',
       disabled: false
     }
   },

   methods: {
     ...mapActions(['bulkAddRecords']),
     async handleFileChange (event) {
       const f = event.target.files[0]
       let reader = new FileReader();
       const vm = this;
       // Closure to capture the file information.
       reader.onload = (function(file) {
         return async function(e) {
           const lines = e.target.result.replace(/"/g, '').split('\n')

           lines.splice(0,6)
           lines.splice(1,1)

           const rows = Papa.parse(lines.join('\n'),
                                   {
                                     delimiter: '\t',
                                     header: true,
                                     skipEmptyLines: 'greedy'
                                   }
           )

           if (rows.data && rows.data.length > 2500) {
             vm.error = 'Too many notes in the import (> 2500). If you can\'t break up the import into smaller chunks, get in touch hello@tatatap.com and we\'ll get it sorted out. Thanks.'
             return
           }
           vm.rows = rows.data
         };
       })(f);

       // Read in the image file as a data URL.
       reader.readAsText(f);
     },

     async renderPreview (rows) {
       const tpl = engine.parse(this.tpl)

       this.notes = await Promise.all(rows.map(async (r) => {
         const bean = r.Amount.substring(0,1) == '-' ? '-"' + this.accountName + '":' + r.Amount.substring(1) : '+"' + this.accountName + '":' + r.Amount;

         const balanced = r.Amount.substring(0,1) == '-' ? '+"???":' + r.Amount.substring(1) : '-"' + this.accountName + '":' + r.Amount;

         const date = DateTime.fromISO(new Date(r.Date).toISOString()).toISODate();
         const description = r.Description;
         const amount = r.Amount

         const note = await engine.render(tpl, {date, bean, description, amount, balanced});

         return {text: note}
       }))


     },

     resetForm () {
       this.rows = []
       this.$refs.file.value = ''
       this.tpl = TPL
       this.accountName = ACCOUNT_NAME
     },

     async handleSubmit () {
       this.disabled = true

       const res = await this.bulkAddRecords({notes: this.notes, type: 'BOA'})

       if (res && res.err) {
         this.error = res.err
       } else {

         this.$toasted.show(`Successfully imported ${res.length} note${res.length > 1 ? 's' : ''}.`, {duration: 3000})

         this.$router.replace({path: '/imports/' + res[0].short_id})
       }

       this.disabled = false

       this.resetForm()
     }
   },

   watch: {
     rows (to) {
       this.renderPreview(to, this.tpl, this.accountName)
     },
     tpl (to) {
       this.renderPreview(this.rows, to, this.accountName)
     },
     accountName (to) {
       this.renderPreview(this.rows, this.tpl, to)
     }
   }

 };
</script>
